import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class FirebaseAuthService {
	constructor(public angularFireAuth: AngularFireAuth) {}

	userCredentials;
	credenciales = new Subject<any>();

	Authenticate(token): void {
		this.angularFireAuth
			.signInWithCustomToken(token)
			.then(
				(userCredentials) => {
					this.userCredentials = userCredentials;
					this.credenciales.next(userCredentials);
					// console.debug('Correctamente identificado', this.userCredentials)
				},
				(error) => console.log('Token rechazado', error)
			)
			.catch(function (error) {
				// |K|
				var errorCode = error.code;
				var errorMessage = error.message;
				console.log('error atajado por el catch: ', errorCode, errorMessage);
			});
	}

	Deauthenticate() {
		this.angularFireAuth
			.signOut()
			.then(function () {
				// Deslogeo correcto
			})
			.catch(function (error) {
				// error
			});
	}
}
